import { makeStyles, Theme } from "@material-ui/core/styles";
import { BaseCSSProperties } from "@material-ui/core/styles/withStyles";
import * as React from "react";
import { useAppState } from "../../../common/appState";
import { spaceBetween } from "../../../common/util/Array/spaceBetween";
import "./style.css";

interface Props {
    style?: BaseCSSProperties;
    children: React.ReactNode;
    hoverScale?: boolean;
}
export const ScrollBox = ({ children, style, hoverScale }: Props) => {
    const c = useStyles({ style });
    const [isDarkMode] = useAppState("isDarkMode");
    return (
        <div
            className={spaceBetween(
                "style-scroll",
                hoverScale && "hoverScale05",
                c.container,
                isDarkMode && "isDarkMode"
            )}
        >
            {children}
        </div>
    );
};
const useStyles = makeStyles<Theme, { style?: BaseCSSProperties }>({
    container: ({ style }) => ({ ...style }),
});
